import React, { useState } from 'react';
import { Button, Typography, CircularProgress } from '@mui/material';
import unifiedApi from '../utils/unifiedApi';

export default function UploadPlayers({ teamId }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage('');
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Please select a CSV file first.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const data = await unifiedApi.uploadTeamPlayersCsv(teamId, file);
      setMessage('Upload successful!');
      console.log('Upload response:', data);
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Upload Players CSV
      </Typography>
      <input
        accept=".csv,text/csv"
        type="file"
        id="csv-upload"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <label htmlFor="csv-upload">
        <Button variant="contained" component="span">
          Choose CSV File
        </Button>
      </label>
      {file && <Typography sx={{ mt: 1 }}>{file.name}</Typography>}

      <div style={{ marginTop: 16 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Upload'}
        </Button>
      </div>

      {message && (
        <Typography
          variant="body1"
          color={message.startsWith('Error') ? 'error' : 'primary'}
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
      )}
    </div>
  );
}